// extracted by mini-css-extract-plugin
module.exports = {"groupTitle":"groupTitle-3knbe"};